import React from 'react'
import Table from '../../components/common/Table'
import { BankDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'

interface BankTableProps {
  data: BankDTO[];
  handleEdit: (row: BankDTO) => void;
  handleDelete: (row: BankDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const BankTable: React.FC<BankTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
                
                    {
                        label: "Name",
                        key: "name",
                    },
        
                    {
                        label: "Branch Code",
                        key: "branchCode",
                    },
        
                {
                    label: "Added",
                    key: "createdUtc",
                    format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
                },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default BankTable;
